import { useContext, useEffect } from 'react'

import ModalContext from 'contexts/ModalContext'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { SET_SHOW_LUX_PLUS_FREE_PREVIEW_MODAL } from 'actions/actionConstants'
import LuxPlusFreePreviewUnlockedModal from 'luxPlus/components/modals/LuxPlusFreePreviewUnlockedModal'

/**
 * Opens the "you've unlocked a free preview" celebration modal once a customer has been enrolled
 * into the LuxPlus+ Free Preview (createFreePreviewMember sets the one-shot flag). The flag is
 * cleared immediately so the modal only shows once. Replaces the old success snackbar.
 */
function useShowLuxPlusFreePreviewUnlockedModal() {
  const showModal = useContext(ModalContext)
  const dispatch = useAppDispatch()
  const shouldShow = useAppSelector(state => state.luxPlus.showFreePreviewEnrolledModal ?? false)

  useEffect(() => {
    if (!shouldShow) return
    dispatch({ type: SET_SHOW_LUX_PLUS_FREE_PREVIEW_MODAL, show: false })
    showModal(<LuxPlusFreePreviewUnlockedModal />)
  }, [shouldShow, dispatch, showModal])
}

export default useShowLuxPlusFreePreviewUnlockedModal
